<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content [class]="getTheme()">

  <div fxLayout="row" class="flexwrap">

    <div fxFlex="100" style="display: flex;">
      <textarea rows="5" matAutosizeMinRows="5" matInput
        [(ngModel)]="data.reason" name="reason" required style="resize: none;"></textarea>
    </div>

  </div>

  @if (data.showChecks) {
    <div fxLayout="column" class="flexwrap">
      <div fxFlex>
        <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.showDiffInDeviations">
          {{ 'protocolEdit.dialog.criticalInstr.showDiffInDeviations.label' | translate }}
        </mat-checkbox>
      </div>
      <div fxFlex>
        <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.showDiffInObservations">
          {{ 'protocolEdit.dialog.criticalInstr.showDiffInObservations.label' | translate }}
        </mat-checkbox>
      </div>
    </div>
  }

</div>

<div mat-dialog-actions align="end" [class]="getTheme()">
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>